import { Injectable } from '@angular/core';
import { TimeLine } from '../models/DeliveryDetails';
import { GET_TIMELINE_IMAGE, STATUS } from "./constants";
import { getApiBaseUrl } from "../config/api";

const DateOptions: Intl.DateTimeFormatOptions = {
  day: '2-digit',
  month: 'short',
  year: '2-digit',
  hour: '2-digit',
  minute: '2-digit',
};

@Injectable({
  providedIn: 'root'
})

export class UtilityService {

  constructor() {
  }

  getFormattedDate(date: Date, length = "short") {
    let dateStr: string = '';
    if (length == 'short') {
      dateStr = date.toLocaleDateString('en-us', { day: "numeric", month: 'short' })
    } else if (length == 'long') {
      const day = String(date.getDate()).padStart(2, '0')
      const month = String(date.getMonth() + 1).padStart(2, '0')
      dateStr = `${day}/${month}/${date.getFullYear()}, ${this.formatAMPM(date).toUpperCase()}`

    }
    return dateStr
  }

  getTime(date: Date) {
    let timeStr = '';
    timeStr = this.formatAMPM(date)
    return timeStr
  }

  formatAMPM(date: Date) {
    let hours = date.getHours();
    let minutes = date.getMinutes();
    let min: any
    let ampm = hours >= 12 ? 'pm' : 'am';
    hours = hours % 12;
    hours = hours ? hours : 12;
    min = minutes < 10 ? '0' + minutes : minutes;
    return hours + ':' + min + ' ' + ampm;
  }

  getCarouselImgUrl(imageId: string, deliveryTokenId: string) {
    return getApiBaseUrl() + GET_TIMELINE_IMAGE + imageId + '?deliveryTokenId=' + deliveryTokenId
  }

  getStatusMsg(e: TimeLine, details: string) {
    switch (e?.['deliveryStatus']) {
      case 'assigned':
        details = 'Waiting for Acceptance';
        break;
      case 'pickedUp':
        details = 'on The Way';
        break;

      case 'deliveryPartnerAcceptedOrder':
        details = 'Picking up your order';
        break;

      case 'lpCancelled':
        details = STATUS[e?.['deliveryStatus']];
        break;
      default:
        details = '';
        break;

    }
    return details;
  }

  transformDeliveryProofDesc(input: string): any[] {
    const result = input.split('<br>');
    // let tempResult = [result[1].split(':')[1],  result[2].split(':')[1], ([result]?.[3] ? result[3].split(':'): '') ]
    return result;
  }

  formatDate(inputDateString: string | undefined) {
    let inputDate: Date;
    if (inputDateString) {

      inputDate = new Date(inputDateString)
      return inputDate.toLocaleDateString('en-US', DateOptions);
    }
    return '-'
  }
}
